import { Component, ViewChild, isDevMode } from '@angular/core';
import { Event, Router, NavigationStart } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { Observable } from 'rxjs/Rx';
import { LoggedInCallback, CognitoCallback, CognitoUtil, Callback } from './cognito/cognito.service';
import { UserLoginService } from './cognito/user-login.service';
import { SharedService } from './shared/shared.service';
import { JwtHelper } from 'angular2-jwt';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [JwtHelper]
})

export class AppComponent implements Callback, LoggedInCallback {
  shouldShowNavbar: boolean;
  @ViewChild(NavbarComponent) navbar: NavbarComponent;

  public constructor(public router: Router, public userService: UserLoginService, public cognitoUtil: CognitoUtil, public service: SharedService, private jwtHelper: JwtHelper) {
    if (!isDevMode()) {
      console.log = function () { };
    }
  }

  ngOnInit() {

    // Get a list of Corporate info loaded every time the app loads
    this.service.syncCorporateInfo();
    // Needed to start callback timer below
    this.userService.isAuthenticated(this);
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    this.cognitoUtil.getAccessToken(this);
    if (!isLoggedIn) {
      console.log('Not logged in.  Sending to login page.');
      this.router.navigate(['/login']);
    }
  }

  callback() {

  }

  // This funciton is used to get a new Cognito token et when the old expires.
  callbackWithParam(result: any) {
    console.log('Refreshed token:', result);
    let d = new Date(0);
    d.setUTCSeconds(this.jwtHelper.decodeToken(result).exp); // Set the date to when the token expires
    console.log('Token expiration time: ', d);
    localStorage.setItem('token', result);
    let timer = Observable.timer(d); // Set a timer that goes off when the token expires
    timer.subscribe(t => {
      console.log('TIMER EXPIRED');
      this.userService.isAuthenticated(this);
    });
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/app.component.ts